import React, { useState } from "react";

// Images (Use actual paths based on your folder structure)
import logo from "../../../assets/images/inc-policy-logo.png";

import imgCustomer from "../../../assets/images/audience-svgrepo-com.svg";
import imgUsers from "../../../assets/images/group-people-svgrepo-com.svg";
import imgDeviceProfile from "../../../assets/images/laptop-svgrepo-com.svg";
import imgDevices from "../../../assets/images/devices-smartphone-svgrepo-com.svg";
import imgRuleChains from "../../../assets/images/chain-hyperlink-interface-svgrepo-com.svg";
import imgRuleEngine from "../../../assets/images/settings-cogwheel-svgrepo-com.svg";
import imgDashboards from "../../../assets/images/dashboard-alt-svgrepo-com.svg";
import imgAssets from "../../../assets/images/wallet-svgrepo-com.svg";

import imgPrivacy from "../../../assets/images/privacy-svgrepo-com.svg";
import imgTerms from "../../../assets/images/policy-term.svg";
import imgLicense from "../../../assets/images/license-svgrepo-com.svg";

import imgRestApi from "../../../assets/images/rest-api.png";
import imgNodeApi from "../../../assets/images/api-code.svg";
import imgCoapApi from "../../../assets/images/coap-api.png";
// import imgTicket from "../../../assets/images/iceApi.svg";

import CustomerOverview from "./Customer";
import PrivacyAgreement from "./PolicyAgreement";
import TermsOfUse from "./TermOfUse";
import UserAgreement from "./UserAgreement";

const HomePage = () => {
  const [showCustomer, setShowCustomer] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTermOfUse, setTermOfUse] = useState(false);
  const [showUser, setUser] = useState(false);

  if (showCustomer) {
    return <CustomerOverview />;
  }
  if (showPrivacy) {
    return <PrivacyAgreement />;
  }
  if (showTermOfUse) {
    return <TermsOfUse />;
  }
  if (showUser) {
    return <UserAgreement />;
  }

  return (
    <>
      <div className="row mb-4">
        <div className="col-lg-12">
          <div className="inc-card">
            <div className="inc-card-title">
              <h3>Features</h3>
            </div>
            <div className="four-grid">
              {[
                {
                  img: imgCustomer,
                  title: "Customer",
                  onClick: () => setShowCustomer(true),
                },
                { img: imgUsers, title: "Users" },
                // { img: imgDeviceProfile, title: "Device Profile" },
                // { img: imgDevices, title: "Devices" },
                // { img: imgRuleChains, title: "Rule Chains" },
                // { img: imgRuleEngine, title: "Rule Engine" },
                // { img: imgDashboards, title: "Dashboards" },
                // { img: imgAssets, title: "Assets" },
              ].map((item, index) => (
                <div
                  className="helpdiv"
                  key={index}
                  onClick={item.onClick}
                  style={{ cursor: item.onClick ? "pointer" : "default" }}
                >
                  <div className="helpimage">
                    <img src={item.img} alt={item.title} />
                  </div>
                  <h3>{item.title}</h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* -------- Agreements Section -------- */}
      <div className="row mb-4">
        <div className="col-lg-12">
          <div className="inc-card">
            <div className="inc-card-title">
              <h3>Agreements</h3>
            </div>
            <div className="four-grid">
              {[
                {
                  img: imgPrivacy,
                  title: "Privacy Policy",
                  onClick: () => setShowPrivacy(true),
                },
                {
                  img: imgTerms,
                  title: "Terms of Use",
                  onClick: () => setTermOfUse(true),
                },
                {
                  img: imgLicense,
                  title: "User License",
                  onClick: () => setUser(true),
                },
              ].map((item, index) => (
                <div
                  className="helpdiv"
                  key={index}
                  onClick={item.onClick}
                  style={{ cursor: item.onClick ? "pointer" : "default" }}
                >
                  <div className="helpimage">
                    <img src={item.img} alt={item.title} />
                  </div>
                  <h3>{item.title}</h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* -------- API Docs Section -------- */}
      <div className="row mb-4">
        <div className="col-lg-12">
          <div className="inc-card">
            <div className="inc-card-title">
              <h3>API Documentations</h3>
            </div>
            <div className="four-grid">
              <div className="helpdiv">
                <div className="helpimage">
                  <img src={imgRestApi} alt="INC API" />
                </div>
                <h3>INC API</h3>
              </div>

              <div className="helpdiv">
                <div className="helpimage">
                  <img src={imgNodeApi} alt="Node API" />
                </div>
                <h3>Node API</h3>
              </div>

              <div className="helpdiv">
                <div className="helpimage">
                  {/* ⚠️ Using public path for problematic SVG */}
                  {/* <img src={imgTicket} alt="Ticketing App" /> */}
                </div>
                <h3>Ticketing App</h3>
              </div>

              <div className="helpdiv">
                <div className="helpimage">
                  <img src={imgCoapApi} alt="P2P COAP API" />
                </div>
                <h3>P2P COAP API</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
